import React from 'react';
import {SvgIconCross} from '../Icon.styled';
import PropTypes from 'prop-types';

const Cross = ({ dataTestId }) => {
  return (
    <SvgIconCross
      data-testid={dataTestId}
      id="Cross"
      data-name="Cross"
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 50 50"
    >

      <path
        d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path>

    </SvgIconCross>
  );
};

Cross.propTypes = {
  dataTestId: PropTypes.string.isRequired,
};

export default Cross;
